<template>
    <div>
        <MainBanner />
        <AboutUsHomePage/>
        <OurDentist class="pt-100" />
        <OurServicesMainPage />
        
        
        <OurClients />
        
        <Blog />
        <div class="video-section-wrapper">
          <VideoSection />
        </div>
        <PartnerCarousel />
        
        
       
    </div>
</template>

<script>
    import MainBanner from '../home-page/MainBanner'
    import AboutUsHomePage from'../home-page/AboutUsHomePage.vue'
    import OurDentist from '../Common/OurDentist'
    import OurClients from '../Common/OurClients'
    import Blog from '../Blog/BlogHomePage'
    import OurServicesMainPage from '../ServicesMainPage/OurServicesMainPage.vue'
    import PartnerCarousel from '../Common/PartnerCarousel.vue'
    import VideoSection from '../Common/VideoSection.vue'

    export default {
    name: 'HomePage',
    components: {
        MainBanner,
        AboutUsHomePage,
        OurServicesMainPage,
        OurDentist,
        PartnerCarousel,
        OurClients,
        Blog,
        VideoSection,
       
    }
}
</script>

<style>
@media (max-width: 640px) {
  .video-section-wrapper {
    display: none;
  }
}
</style>